export default __webpack_public_path__ + "static/media/users-active.e9579827.svg";